<template>
    <div class="model-item">
        <div class="image-container">
            <img v-if="trailer.image_url" :src="trailer.image_url" :alt="trailer.name" class="trailer-image" />
        </div>
        <div class="model-details">
            <h3 class="model-name">{{ trailer.name }}</h3>

            <p class="model-specs">
                <span><strong>Wymiar:</strong> {{ trailer.width }} x {{ trailer.height }} cm</span><br>
                <span><strong>Masa własna:</strong> {{ trailer.weight }} kg</span><br>
                <span><strong>Dopuszczalna masa całkowita:</strong> {{ trailer.dmc }} kg</span>
            </p>

            <p class="model-description">{{ shortDescription }}</p>
            <p class="price">Od {{ formatPrice(trailer.price) }} zł</p>
            <button class="details-button" @click="showDetails">Wyposażenie standardowe</button>
            <button class="select-button" @click="selectTrailer">Wybierz</button>
        </div>
    </div>

    <ResumeConfig v-if="showResumeModal" @continue="handleResume" @cancel="handleCancelResume" />

    <transition name="fade">
        <TrailerDetails v-if="isModalVisible" :trailer="trailer" @close="closeModal" />
    </transition>
</template>

<script>
import {
    useTrailerStore
} from '@/stores/trailerStore'
import TrailerDetails from './TrailerDetails.vue'
import ResumeConfig from '@/components/configurator-page/ResumeConfig.vue';
import {
    getConfigFromStorage,
    clearConfigStorage
} from '@/services/configStorage.js';

export default {
    components: {
        TrailerDetails,
        ResumeConfig
    },
    props: {
        trailer: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            isModalVisible: false,
            showResumeModal: false,
        }
    },
    computed: {
        trailerStore() {
            return useTrailerStore()
        },
        formatPrice() {
            return this.trailerStore.formatPrice
        },
        shortDescription() {
            const text = this.trailer.description || ''
            return text.length > 100 ? text.slice(0, 100) + '…' : text
        }
    },
    async created() {
        const saved = getConfigFromStorage();
        if (saved && !this.trailerStore.selectedTrailer) {
            this.showResumeModal = true;
        }
    },
    methods: {
        async selectTrailer() {
            const saved = getConfigFromStorage();

            if (saved) {
                this.showResumeModal = true;
            } else {
                this.trailerStore.selectTrailer(this.trailer);
                this.$router.push('/configurator');
            }
        },
        async showDetails() {
            await this.trailerStore.selectTrailer(this.trailer)
            this.isModalVisible = true
        },
        closeModal() {
            this.isModalVisible = false
        },
        handleResume() {
            this.showResumeModal = false;
            this.$router.push('/configurator');
        },
        handleCancelResume() {
            clearConfigStorage();
            this.showResumeModal = false;
            this.trailerStore.selectTrailer(this.trailer);
            this.$router.push('/configurator');
        }
    }
}
</script>

<style scoped lang="scss">
.model-item {
    border: 1px solid $color-grey;
    border-radius: 6px;
    overflow: hidden;
    transition: all 0.25s ease;
    background: $color-white;
    position: relative;

    &:hover {
        transform: translateY(-5px);
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
        border-color: $color-primary-light;

        .select-button {
            background-color: $color-primary;
            color: $color-white;
        }
    }
}

.image-container {
    padding: 15px;
    background: $color-grey-light;

    img {
        width: 100%;
        height: 160px;
        object-fit: contain;
        display: block;
    }
}

.model-details {
    padding: 15px;
    position: relative;
}

.model-name {
    font-size: 1.1rem;
    font-weight: 500;
    margin: 0 0 8px 0;
    color: $color-text;
}

strong {
    color: $color-text;
}

.model-specs {
    font-size: 0.85rem;
    color: $color-text-light;
    margin: 0 0 8px 0;
}

.model-description {
    font-size: 0.88rem;
    color: $color-text-light;
    margin: 0 0 10px 0;
    line-height: 1.35;
    text-align: left;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    line-clamp: 3;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
}

.price {
    font-weight: 600;
    color: $color-primary;
    margin: 0 0 12px 0;
    font-size: 1rem;
}

.details-button {
    width: 100%;
    padding: 8px 0;
    background-color: transparent;
    border: 1px solid $color-primary;
    border-radius: 4px;
    color: $color-primary;
    font-weight: 500;
    font-size: 0.85rem;
    cursor: pointer;
    margin-bottom: 10px;
    transition: all 0.25s ease;

    &:hover {
        background-color: $color-primary;
        color: $color-white;
    }
}

.select-button {
    width: 100%;
    padding: 8px 0;
    background-color: $color-grey-light;
    border: none;
    border-radius: 4px;
    color: $color-primary;
    font-weight: 500;
    font-size: 0.85rem;
    cursor: pointer;
    transition: all 0.25s ease;
    outline: none;

    &:hover {
        background-color: $color-primary-dark;
    }
}

@media (max-width: 768px) {
    .model-item {
        display: flex;
        align-items: center;

        .image-container {
            background-color: transparent;
            flex: 0 0 120px;
            padding: 10px;

            img {
                height: 80px;
            }
        }

        .select-button,
        .details-button {
            padding: 6px 0;
            font-size: 0.85rem;
        }
    }
}
</style>